
export default function Meat() {
        return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6">
      {/* Department Title */}
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-10">
           Meat
          </h2>

      {/* Image Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 max-w-5xl">
        <img
          src="https://media.istockphoto.com/id/1438426028/photo/usda-choice-beef-rib-eye-steaks-for-sale-at-a-supermarket.jpg?s=612x612&w=0&k=20&c=FCcdQ-BYaOZbVJo623TCQpLY-uoI4DQgAG6fD6Vkngc="
          alt="Steak"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="https://www.shutterstock.com/image-photo/rear-view-man-supermarket-working-600nw-2353690589.jpg"
          alt="Butcher restocking meat case"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
        <img
          src="https://media.istockphoto.com/id/2170635031/photo/a-cropped-shot-of-a-woman-selecting-raw-chicken-meat-at-a-grocery-store.jpg?s=612x612&w=0&k=20&c=IWkqW4144jG0c4pRx08RWoSrdnnH6VfLpBcyA_CDiR8="
          alt="Person holding fresh chicken"
          className="rounded-2xl shadow-lg w-full h-64 object-cover"
        />
      </div>

      {/* Description */}
      <div className="max-w-3xl text-center p-6">
        <p className="text-gray-700 text-lg leading-relaxed">
          Our Meat Department offers fresh, high-quality cuts of beef, chicken, and more. Everything is carefully prepared and stocked daily.
        </p>
      </div>
    </div>
  );
}